import { useQuery } from "@tanstack/react-query";
import { searchPlaces } from "../api/planner";

export const useSearchPlaces = (query: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["places", query],
    queryFn: () => searchPlaces(query),
    enabled: enabled && !!query,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
};
